var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionCrossIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7556 17.0005L26.0642 10.6919C26.3636 10.393 26.532 9.98746 26.5324 9.56441C26.5328 9.14137 26.3651 8.7355 26.0662 8.43609C25.7673 8.13669 25.3618 7.96827 24.9387 7.9679C24.5157 7.96753 24.1098 8.13522 23.8104 8.4341L17.5018 14.7427L11.1932 8.4341C10.8938 8.1347 10.4877 7.96649 10.0643 7.96649C9.64087 7.96649 9.23479 8.1347 8.93538 8.4341C8.63598 8.7335 8.46777 9.13958 8.46777 9.56301C8.46777 9.98643 8.63598 10.3925 8.93538 10.6919L15.244 17.0005L8.93538 23.3091C8.63598 23.6085 8.46777 24.0146 8.46777 24.438C8.46777 24.8614 8.63598 25.2675 8.93538 25.5669C9.23479 25.8663 9.64087 26.0345 10.0643 26.0345C10.4877 26.0345 10.8938 25.8663 11.1932 25.5669L17.5018 19.2583L23.8104 25.5669C24.1098 25.8663 24.5159 26.0345 24.9393 26.0345C25.3627 26.0345 25.7688 25.8663 26.0682 25.5669C26.3676 25.2675 26.5358 24.8614 26.5358 24.438C26.5358 24.0146 26.3676 23.6085 26.0682 23.3091L19.7556 17.0005Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionCrossIc);
export default __webpack_public_path__ + "static/media/subscription_cross_ic.ccf9d0ee2ea774b12dad4ac10ad93815.svg";
export { ForwardRef as ReactComponent };